const TicketPlaceholder = (props) => {
    return(
        <>
            <div className="p-3 bg-white align-items-center justify-content-between d-flex flex-row placeholder-glow">
                <div className="d-flex flex-column w-100">
                    <p className="text-truncate placeholder w-50 mb-2" />
                    <p className="text-truncate placeholder w-25" />
                </div>
            </div> 
        </>
    )
}   
export default TicketPlaceholder;